module.exports = __webpack_public_path__ + "img/CleanManager.c127d5ed.png";